(function(){
  const money = (cents) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-AU',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'AUD'}).format(cents/100); }
    catch(e){ return '$'+(cents/100).toFixed(2); }
  };

  document.addEventListener('click', (e) => {
    const thumb=e.target.closest('[data-gallery-thumb]');
    if(thumb){
      const gallery=thumb.closest('[data-gallery]');
      const main=gallery && gallery.querySelector('[data-main-image]');
      if(main){ main.src=thumb.dataset.src; gallery.querySelectorAll('[data-gallery-thumb]').forEach(t=>t.classList.toggle('is-active',t===thumb)); }
    }
    if(e.target.closest('[data-qty-minus]')||e.target.closest('[data-qty-plus]')){
      const root=e.target.closest('.product-form'); if(!root)return;
      const input=root.querySelector('[data-qty]'); if(!input)return;
      const delta=e.target.closest('[data-qty-plus]')?1:-1;
      input.value=Math.max(1,(parseInt(input.value,10)||1)+delta);
    }
    if(e.target.closest('[data-cart-open]')) openCart();
    if(e.target.closest('[data-cart-close]')||e.target.matches('[data-cart-backdrop]')) closeCart();
    const menuBtn=e.target.closest('[data-menu-toggle]');
    if(menuBtn){ const m=document.querySelector('[data-mobile-menu]'); if(m) m.hidden=!m.hidden; }
  });

  document.addEventListener('change', (e) => {
    if(e.target.matches('[data-variant-radio]')){
      const root=e.target.closest('[data-product-root]');
      const price=root && root.querySelector('[data-product-price]');
      const compare=root && root.querySelector('[data-compare-price]');
      if(price) price.textContent=money(parseInt(e.target.dataset.price,10)||0);
      if(compare){ const c=parseInt(e.target.dataset.compare,10)||0; compare.textContent=c?money(c):''; compare.hidden=!c; }
    }
  });

  document.addEventListener('submit', async (e) => {
    const form=e.target.closest('.product-form'); if(!form)return;
    e.preventDefault();
    const btn=form.querySelector('[data-add-button]'); const text=form.querySelector('[data-add-text]');
    if(btn) btn.classList.add('is-loading'); if(text) text.textContent='Adding…';
    try{
      const res=await fetch('/cart/add.js',{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest'},body:new FormData(form)});
      if(!res.ok) throw new Error('Unable to add item');
      await refreshCart(); openCart();
      if(text) text.textContent='Added';
      setTimeout(()=>{if(text)text.textContent='Add to cart';},1200);
    }catch(err){
      if(text) text.textContent='Try again';
      setTimeout(()=>{if(text)text.textContent='Add to cart';},1600);
    }finally{ if(btn) btn.classList.remove('is-loading'); }
  });

  function openCart(){
    const d=document.querySelector('[data-cart-drawer]'), b=document.querySelector('[data-cart-backdrop]');
    if(!d||!b)return; b.hidden=false; requestAnimationFrame(()=>d.classList.add('is-open')); d.setAttribute('aria-hidden','false'); document.body.classList.add('drawer-open');
  }
  function closeCart(){
    const d=document.querySelector('[data-cart-drawer]'), b=document.querySelector('[data-cart-backdrop]');
    if(!d||!b)return; d.classList.remove('is-open'); d.setAttribute('aria-hidden','true'); document.body.classList.remove('drawer-open'); setTimeout(()=>b.hidden=true,260);
  }
  async function refreshCart(){
    const r=await fetch('/cart.js',{headers:{'Accept':'application/json'}}); const cart=await r.json();
    document.querySelectorAll('[data-cart-count]').forEach(x=>x.textContent=cart.item_count);
    const dc=document.querySelector('[data-drawer-count]'); if(dc) dc.textContent='('+cart.item_count+')';
    const items=document.querySelector('[data-cart-items]'); const foot=document.querySelector('[data-cart-footer]'); const total=document.querySelector('[data-cart-total]');
    if(total) total.textContent=money(cart.total_price);
    if(foot) foot.hidden=cart.item_count===0;
    if(!items)return;
    if(cart.item_count===0){items.innerHTML='<div class="drawer-empty"><p>Your cart is empty.</p><button class="button button--secondary" type="button" data-cart-close>Continue shopping</button></div>';return;}
    items.innerHTML=cart.items.map(i=>`<div class="drawer-item">${i.image?`<img src="${i.image}" alt="" width="90" height="90">`:''}<div><strong>${escapeHtml(i.product_title)}</strong>${i.variant_title&&i.variant_title!=='Default Title'?`<small>${escapeHtml(i.variant_title)}</small>`:''}<small>Qty ${i.quantity}</small><span>${money(i.final_line_price)}</span></div></div>`).join('');
  }
  function escapeHtml(s){return String(s||'').replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));}
})();
